var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "toolbar",
        {
          attrs: {
            loading: !_vm._.get(_vm.currentLoad, "humanId", null),
            title:
              "Load " +
              _vm._.get(_vm.currentLoad, "humanId", null) +
              " " +
              _vm._.get(_vm.currentLoad, "loadStatus", "Unknown")
          }
        },
        [
          _c(
            "v-icon",
            {
              on: {
                click: function($event) {
                  return _vm.refreshCurrentLoad()
                }
              }
            },
            [_vm._v("refresh")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.currentLoad
        ? _c("load-detail-component", {
            staticClass: "pl-2",
            attrs: {
              currentLoad: _vm.currentLoad,
              company: _vm.company,
              loading: _vm.loadingLoad
            },
            on: {
              removeLoad: function($event) {
                return _vm.removeLoad($event)
              },
              refreshLoad: _vm.refreshCurrentLoad
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7af0cd97", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7af0cd97","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Loads/Detail.vue
// module id = null
// module chunks = 